import React, { createContext, useContext, useState, useCallback } from 'react';
import es from './es.json';
import en from './en.json';
import fr from './fr.json';
import pt from './pt.json';
import ca from './ca.json';

const messages = { es, en, fr, pt, ca };
const LANGUAGES = [
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
  { code: 'ca', label: 'Català', flag: '🏴' },
];

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    const saved = localStorage.getItem('evplanner-lang');
    if (saved && messages[saved]) return saved;
    const browser = navigator.language?.slice(0, 2);
    return messages[browser] ? browser : 'es';
  });

  const t = useCallback((key, params) => {
    let text = messages[locale]?.[key] || messages.es[key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, v);
      });
    }
    return text;
  }, [locale]);

  const changeLocale = useCallback((code) => {
    if (messages[code]) {
      setLocale(code);
      localStorage.setItem('evplanner-lang', code);
    }
  }, []);

  return (
    <I18nContext.Provider value={{ locale, t, changeLocale, languages: LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
